export const RIGHT_MANAGMENT_CHANGE_FOR_GROUPE = 'RIGHT_MANAGMENT_CHANGE_FOR_GROUPE';
export const RIGHT_MANAGMENT_CHANGE_FOR_KEY = 'RIGHT_MANAGMENT_CHANGE_FOR_KEY';
